import React from 'react';
import useScrollTop from '../hooks/useScrollTop';
import angle_up from '../svgs/angle-double-up.svg';
import { motion, AnimatePresence } from 'framer-motion';

const buttonVariants = {
	initial: {
		bottom: -75,
	},
	animate: {
		bottom: 30,
	},
};

function Footer() {
	const { top } = useScrollTop(window);

	function toTop() {
		window.scroll({ top: 0, behavior: 'smooth' });
	}

	return (
		<React.Fragment>
			<footer className="ln-top">
				<div className="inner pd-md-v xl-pd-none flex align-center flex-wrap">
					<div className="flex align-center pd-xl-h">
						<p>Copyright &copy; 2021. All Rights Reserved.</p>
					</div>
				</div>
			</footer>
			<div className="f-footer">
				<AnimatePresence>
					{top > 400 && (
						<motion.button variants={buttonVariants} initial="initial" animate="animate" exit={{ bottom: -75 }} className="top-btn elevate circle bg-secondary" type="button" onClick={() => toTop()}>
							<img src={angle_up} alt="" />
						</motion.button>
					)}
				</AnimatePresence>
			</div>
		</React.Fragment>
	);
}

export default Footer;
